var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"page-title"},[_vm._v("整体报告")]),_c('panel',{attrs:{"url":_vm.url,"bg-url":_vm.bgUrl,"content":_vm.content,"bg-align":"left-bottom","section":"信息传递"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }